/**
 * Default dialect for student Live Tutor (`dialect_key` query param, etc.).
 * Must match Mongo `dialect_profiles.key`. Server `/v1/tutor/dialect-options` is the options source of truth.
 */
export const DEFAULT_STUDENT_TUTOR_DIALECT_KEY = "standard_tamil";

/**
 * When `/v1/tutor/dialect-options` returns a non-empty list:
 * 1) keep `prev` if it still exists in `cleaned`
 * 2) else prefer {@link DEFAULT_STUDENT_TUTOR_DIALECT_KEY} if present
 * 3) else use first server entry (`cleaned[0].key`)
 */
export function pickDialectKeyFromServerList(
  prev: string,
  cleaned: { key: string; name: string }[]
): string {
  if (cleaned.length === 0) return prev;
  if (cleaned.some((d) => d.key === prev)) return prev;
  const preferred = cleaned.find((d) => d.key === DEFAULT_STUDENT_TUTOR_DIALECT_KEY);
  if (preferred) return preferred.key;
  return cleaned[0].key;
}
